// AYA PRO — Accueil du parcours professionnel (maquette Réf 4, écran 1 : hero sombre masque).
import { useNavigate } from "react-router-dom";
import { TrendingUp, Users, Settings, LogIn, ChevronRight } from "lucide-react";
import { AyaProLogo } from "@/components/pro/AyaProLogo";
import "./ayapro.css";

const BENEFITS = [
  { Icon: TrendingUp, t: "Plus de visibilité", s: "auprès de millions d'utilisateurs" },
  { Icon: Users, t: "Recevez des clients", s: "et des demandes de devis" },
  { Icon: Settings, t: "Gérez votre activité", s: "simplement et efficacement" },
];

export default function AyaProStartPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="ayapro-start-page" style={{ minHeight: "100vh", fontFamily: "'Manrope', system-ui, sans-serif", background: "radial-gradient(ellipse at 80% 20%, #0B3B24 0%, #062417 45%, #04140C 100%)", color: "#F0FBF4", position: "relative", overflow: "hidden" }}>
      <img src="/aya/splash.png" alt="" aria-hidden="true" style={{ position: "absolute", right: -70, top: 60, width: 320, opacity: 0.2, filter: "drop-shadow(0 0 30px rgba(212,175,55,0.35))", pointerEvents: "none" }} />
      <div style={{ maxWidth: 520, margin: "0 auto", padding: "18px 22px 40px", position: "relative", display: "flex", flexDirection: "column", minHeight: "100vh", boxSizing: "border-box" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <AyaProLogo variant="hero" />
          <span style={{ fontSize: 13, fontWeight: 800, color: "#CFE5D6" }}>FR ▾</span>
        </div>
        <h1 style={{ margin: "34px 0 0", fontSize: 34, fontWeight: 900, lineHeight: 1.15, letterSpacing: -0.5, maxWidth: 300 }}>
          Développez votre activité avec <span style={{ color: "#2EE27B" }}>AYA PRO</span>
        </h1>
        <p style={{ margin: "12px 0 0", fontSize: 13.5, color: "#A9C6B4", lineHeight: 1.55, maxWidth: 300 }}>
          La plateforme des professionnels de Côte d'Ivoire et d'Afrique
        </p>
        <div style={{ display: "grid", gap: 16, marginTop: 30 }}>
          {BENEFITS.map(({ Icon, t, s }) => (
            <div key={t} style={{ display: "flex", gap: 13, alignItems: "center" }}>
              <span style={{ width: 46, height: 46, borderRadius: "50%", background: "rgba(46,226,123,0.14)", border: "1px solid rgba(46,226,123,0.35)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon size={20} color="#2EE27B" />
              </span>
              <div>
                <div style={{ fontSize: 14.5, fontWeight: 900 }}>{t}</div>
                <div style={{ fontSize: 12, color: "#A9C6B4", marginTop: 1 }}>{s}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: "auto", paddingTop: 36 }}>
          <button className="ap-cta" onClick={() => navigate("/pro/inscription")} data-testid="ayapro-start-create">
            Créer un compte pro <ChevronRight size={17} />
          </button>
          <button className="ap-cta" style={{ background: "transparent", border: "1.5px solid rgba(240,251,244,0.55)", boxShadow: "none", marginTop: 12 }} onClick={() => navigate("/pro/connexion")} data-testid="ayapro-start-login">
            <LogIn size={16} /> Se connecter
          </button>
          <div style={{ textAlign: "center", marginTop: 16, fontSize: 12, color: "#A9C6B4" }}>
            Déjà un compte ? <button onClick={() => navigate("/pro/connexion")} style={{ background: "none", border: "none", color: "#fff", fontWeight: 800, cursor: "pointer", textDecoration: "underline", fontSize: 12, padding: 0 }} data-testid="ayapro-start-login-link">Connectez-vous</button>
          </div>
        </div>
      </div>
    </div>
  );
}
